/**
 * controls the dropdown menu element
 */

import $ from 'jquery';

/**
 *
 */
export default class Menu {

	constructor(options) {
		this.id = options.id;
		this.name = options.rootId + '__menu';
		this.transitionSpeed = options.transitionSpeed || 400;
		this.activeTaxonomy = '';
		this.events = options.events;
		this.init.call(this);
	}

	/**
	*
	 */
	init(options) {
		this.setLinks().registerListeners();
	}

	/**
	 * @chainable
	 */
	registerListeners() {
		this.listeners = this.links.map((link) => { link.addEventListener('click', this.onClick.bind(this)); })
		return this;
	}

	/**
	 * @chainable
	 */
	setLinks() {
		this.links = Array.prototype.slice.call(document.getElementById(this.id).getElementsByTagName('a'));
		return this;
	}

	/**
	 * @param   Object
	 * @chainable
	 */
	onClick(event) {
		event.preventDefault();
		this.events.emit('menu--close', {}, event);
		(function(window) {
			window.setTimeout(() => {
				window.location.href = event.target.href;
			}, 200);
		})(window);
	}

	/**
	 * @chainable
	 */
	setActiveTaxonomy(activeTaxonomy) {
		this.activeTaxonomy = activeTaxonomy;
		return this;
	}

	/**
	 * the menu element contains multiple 'menus', server-generated menus
	 * the activeTaxonomy property is used to select the active menu
	 * @todo    register all menus on instantiation
	 * @todo    rethink active taxonomy name
	 * @param   String
	 * @chainable
	 */
	setActiveMenu() {
		this.activeMenu = document.getElementById(this.activeTaxonomy + '-categories');
		return this;
	}

	/**
	 *
	 * @param   String
	 * @chainable
	 */
	configure(data) {
		// set active taxonomy data attribute
		this.setActiveTaxonomy(data.taxonomy)
			.setActiveMenu();
		return this;
	}

	/**
	 *
	 */
	toggleMenu() {

	}

	/**
	 * @chainable
	 */
	show() {
		$(this.activeMenu).removeClass(this.name + '--inactive');
		$(this.activeMenu).addClass(this.name + '--active');
		return this;
	}

	/**
	 * @chainable
	 */
	hide() {
		$(this.activeMenu).removeClass(this.name + '--active');
		$(this.activeMenu).addClass(this.name + '--inactive');
		return this;
	}

	/**
	 * @chainable
	 */
	reset() {
		this.activeTaxonomy = '';
		return this;
	}

}